import { isEmpty } from 'lodash/fp';
import React from 'react';

import { RenderMenuProps } from '../../../../types';

const Menu = ({ getMenuProps, isOpen, menuItems }: RenderMenuProps) => {
  if (!isOpen || isEmpty(menuItems)) {
    return null;
  }
  return <div {...getMenuProps()}>{menuItems}</div>;
};
export default Menu;
